// Choosing what a journal is bound in. Shared by create and edit, as in the reference.

import { Cover } from './Cover';
import { FREE_COVERS, TEMPLATE_COVERS, type CoverDesign } from './covers';

export function CoverPicker({
  coverId,
  onPick,
}: {
  coverId: string;
  onPick(id: string): void;
}) {
  const rail = (label: string, covers: CoverDesign[]) => (
    <div className="nc-field">
      <span className="nc-label">{label}</span>
      <div className="cvr-rail" role="radiogroup" aria-label={label}>
        {covers.map((cover) => (
          <button
            key={cover.id}
            role="radio"
            aria-checked={coverId === cover.id}
            className={`cvr-opt ${coverId === cover.id ? 'on' : ''}`}
            onClick={() => onPick(cover.id)}
          >
            <Cover cover={cover} size="sm" />
            <span>{cover.name}</span>
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <>
      {rail('Cover', FREE_COVERS)}
      {rail('Template covers', TEMPLATE_COVERS)}
    </>
  );
}
